import { TeamTypeahead, UserTypeahead } from '../models';

export class UserTeam {
    public teamID?: number;
    public team?: TeamTypeahead;
    public userID?: number;
    public user?: UserTypeahead;
    public isManager: boolean;
    public isMember: boolean;
}


// WEBPACK FOOTER //
// ./src/models/UserTeam.tsx